import React from "react";
import { Tooltip, makeStyles } from "@material-ui/core";
import { green, grey, orange } from "@material-ui/core/colors";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";

const useStyles = makeStyles((theme) => ({
  on: {
    color: green[600],
    fontSize: "20px",
  },
  off: {
    color: grey[600],
    fontSize: "20px",
  },
  vacation: {
    color: orange[800],
    fontSize: "20px",
  },
}));

const UserStatusIcon = ({ user }) => {
  const classes = useStyles();

  if (!user) {
    return (
      <Tooltip title="Desconhecido">
        <ErrorIcon className={classes.off} />
      </Tooltip>
    );
  }

  // 🏖️ Verifica se o usuário está de férias ou ausente
  const isVacation = Boolean(
    user.onVacation ||
    (user.absenceType && user.absenceType !== "active")
  );

  let inVacationPeriod = isVacation;
  if (user.vacationStart && user.vacationEnd) {
    const now = new Date();
    inVacationPeriod = now >= new Date(user.vacationStart) && now <= new Date(user.vacationEnd);
  }

  if (inVacationPeriod) {
    const absenceLabel =
      user.absenceType === "leave"
        ? "Licença Médica"
        : user.absenceType === "dayoff"
        ? "Folga"
        : user.absenceType === "pause"
        ? "Pausa"
        : "Em Férias";

    let tooltipText = `${absenceLabel}`;
    if (user.absenceReason) {
      tooltipText += `: ${user.absenceReason}`;
    }
    if (user.vacationEnd) {
      const formattedEnd = new Date(user.vacationEnd).toLocaleDateString("pt-BR");
      tooltipText += ` (até ${formattedEnd})`;
    }

    return (
      <Tooltip title={tooltipText}>
        <BeachAccessIcon className={classes.vacation} />
      </Tooltip>
    );
  }

  if (typeof user.online === "undefined") {
    return (
      <Tooltip title="Desconhecido">
        <ErrorIcon className={classes.off} />
      </Tooltip>
    );
  }

  return user.online ? (
    <Tooltip title="Online">
      <CheckCircleIcon className={classes.on} />
    </Tooltip>
  ) : (
    <Tooltip title="Offline">
      <ErrorIcon className={classes.off} />
    </Tooltip>
  );
};

export default UserStatusIcon;
